export interface Movie {
  id: number;
  title: string;
  subtitle: string;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  quality: string;
  duration: string;
  hot: number;
  poster: string;
  synopsis: string;
}

export interface UpdateMovie {
  id: number;
  title: string;
  episode: string;
  quality: string;
  time: string;
  region: string;
  genre: string;
  poster: string;
}

export interface FeaturedMovie {
  id: number;
  title: string;
  tagline: string;
  rating: number;
  quality: string;
  genres: string;
  cover: string;
}

export interface UpcomingMovie {
  id: number;
  title: string;
  month: string;
  reason: string;
  genre: string;
  poster: string;
}

export interface GenreCategory {
  id: number;
  name: string;
  count: number;
  icon: string;
  desc: string;
}

export interface GuideStep {
  id: number;
  title: string;
  desc: string;
  icon: string;
}

export interface FaqItem {
  id: number;
  q: string;
  a: string;
}

export const featuredMovies: FeaturedMovie[] = [
  {
    id: 1,
    title: '暗夜追缉',
    tagline: '一场横跨雨夜都市的极限追踪，真相藏在每一个转角',
    rating: 9.1,
    quality: '4K HDR',
    genres: '动作 · 犯罪 · 悬疑',
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20rainy%20city%20night%20street%2C%20lone%20silhouette%20under%20neon%20reflections%2C%20moody%20crimson%20and%20amber%20lighting%2C%20film%20noir%20atmosphere%2C%20dramatic%20composition%2C%20editorial%20movie%20key%20art%2C%20no%20text&width=1200&height=800&seq=wsr-feature-01&orientation=landscape',
  },
  {
    id: 2,
    title: '星际回声',
    tagline: '人类最后一次向深空发送的信号，等来的并不是沉默',
    rating: 8.8,
    quality: '4K HDR',
    genres: '科幻 · 冒险 · 剧情',
    cover:
      'https://readdy.ai/api/search-image?query=distant%20planet%20horizon%20with%20giant%20ringed%20world%2C%20lone%20spacecraft%20silhouette%2C%20warm%20amber%20and%20deep%20teal%20nebula%20sky%2C%20cinematic%20science%20fiction%20key%20art%2C%20soft%20glow%2C%20no%20text&width=900&height=800&seq=wsr-feature-02&orientation=landscape',
  },
  {
    id: 3,
    title: '云端奇旅',
    tagline: '一场写给天空与童年的温柔冒险',
    rating: 8.9,
    quality: '蓝光',
    genres: '动画 · 家庭 · 奇幻',
    cover:
      'https://readdy.ai/api/search-image?query=whimsical%20floating%20islands%20above%20golden%20cloud%20sea%20at%20sunset%2C%20tiny%20airship%2C%20warm%20pastel%20orange%20and%20cream%20palette%2C%20storybook%20animation%20key%20art%2C%20dreamy%20light%2C%20no%20text&width=900&height=800&seq=wsr-feature-03&orientation=landscape',
  },
];

export const todayUpdates: UpdateMovie[] = [
  {
    id: 101,
    title: '雾都谜案',
    episode: '正片',
    quality: '1080P',
    time: '10:20',
    region: '中国大陆',
    genre: '悬疑 · 犯罪',
    poster:
      'https://readdy.ai/api/search-image?query=foggy%20victorian%20style%20alley%2C%20lone%20figure%20with%20umbrella%2C%20cold%20grey%20mist%20with%20warm%20lamp%20glow%2C%20mystery%20thriller%20movie%20poster%20art%2C%20moody%20cinematic%20lighting%2C%20no%20text&width=600&height=900&seq=wsr-today-01&orientation=portrait',
  },
  {
    id: 102,
    title: '欢乐大作战',
    episode: '正片',
    quality: '1080P',
    time: '09:45',
    region: '中国大陆',
    genre: '喜剧 · 都市',
    poster:
      'https://readdy.ai/api/search-image?query=bright%20playful%20city%20street%20in%20daytime%2C%20colorful%20balloons%20and%20confetti%2C%20cheerful%20sunny%20palette%20of%20coral%20and%20yellow%2C%20lively%20comedy%20poster%20art%2C%20clean%20background%2C%20no%20text&width=600&height=900&seq=wsr-today-02&orientation=portrait',
  },
  {
    id: 103,
    title: '量子边界',
    episode: '正片',
    quality: '4K',
    time: '09:10',
    region: '美国',
    genre: '科幻 · 悬疑',
    poster:
      'https://readdy.ai/api/search-image?query=abstract%20glowing%20geometric%20portal%20chamber%2C%20scientist%20silhouette%2C%20amber%20and%20emerald%20energy%20glow%2C%20high%20tech%20science%20fiction%20poster%20art%2C%20dark%20cinematic%20atmosphere%2C%20no%20text&width=600&height=900&seq=wsr-today-03&orientation=portrait',
  },
  {
    id: 104,
    title: '归乡之路',
    episode: '正片',
    quality: '1080P',
    time: '08:30',
    region: '中国大陆',
    genre: '剧情 · 家庭',
    poster:
      'https://readdy.ai/api/search-image?query=warm%20countryside%20road%20at%20golden%20hour%2C%20lone%20traveler%20with%20backpack%2C%20golden%20wheat%20fields%20and%20soft%20haze%2C%20emotional%20drama%20poster%20art%2C%20nostalgic%20amber%20tones%2C%20no%20text&width=600&height=900&seq=wsr-today-04&orientation=portrait',
  },
  {
    id: 105,
    title: '暗巷回响',
    episode: '正片',
    quality: '蓝光',
    time: '07:55',
    region: '韩国',
    genre: '惊悚 · 恐怖',
    poster:
      'https://readdy.ai/api/search-image?query=dark%20narrow%20alley%20with%20flickering%20lamp%2C%20long%20dramatic%20shadow%2C%20deep%20shadow%20with%20muted%20red%20rim%20light%2C%20horror%20thriller%20poster%20art%2C%20eerie%20cinematic%20mood%2C%20no%20text&width=600&height=900&seq=wsr-today-05&orientation=portrait',
  },
  {
    id: 106,
    title: '夏末信笺',
    episode: '正片',
    quality: '1080P',
    time: '07:20',
    region: '日本',
    genre: '爱情 · 剧情',
    poster:
      'https://readdy.ai/api/search-image?query=seaside%20town%20at%20dusk%2C%20girl%20holding%20letter%20by%20railing%2C%20soft%20pink%20and%20peach%20sky%2C%20romantic%20slice%20of%20life%20poster%20art%2C%20gentle%20sunset%20light%2C%20no%20text&width=600&height=900&seq=wsr-today-06&orientation=portrait',
  },
];

export const hotMovies: Movie[] = [
  {
    id: 201,
    title: '铁血归途',
    subtitle: 'Iron Return',
    year: 2025,
    region: '中国大陆',
    genres: ['动作', '战争'],
    rating: 8.7,
    quality: '4K HDR',
    duration: '128分钟',
    hot: 98600,
    poster:
      'https://readdy.ai/api/search-image?query=rugged%20soldier%20silhouette%20against%20smoky%20battlefield%20dawn%2C%20embers%20in%20air%2C%20warm%20amber%20and%20charcoal%20palette%2C%20epic%20war%20film%20poster%20art%2C%20dramatic%20lighting%2C%20no%20text&width=600&height=900&seq=wsr-hot-01&orientation=portrait',
  },
  {
    id: 202,
    title: '破晓行动',
    subtitle: 'Dawn Operation',
    year: 2025,
    region: '中国香港',
    genres: ['动作', '犯罪'],
    rating: 8.4,
    quality: '1080P',
    duration: '116分钟',
    hot: 87200,
    poster:
      'https://readdy.ai/api/search-image?query=helicopter%20over%20glassy%20city%20skyline%20at%20sunrise%2C%20agent%20silhouette%20on%20rooftop%2C%20orange%20and%20slate%20tone%2C%20action%20thriller%20poster%20art%2C%20dynamic%20composition%2C%20no%20text&width=600&height=900&seq=wsr-hot-02&orientation=portrait',
  },
  {
    id: 203,
    title: '火星纪元',
    subtitle: 'Mars Era',
    year: 2025,
    region: '美国',
    genres: ['科幻', '冒险'],
    rating: 8.6,
    quality: '4K HDR',
    duration: '142分钟',
    hot: 95400,
    poster:
      'https://readdy.ai/api/search-image?query=red%20desert%20colony%20dome%20on%20mars%2C%20two%20suns%20low%20horizon%2C%20rust%20orange%20and%20dusty%20rose%20palette%2C%20grand%20sci-fi%20poster%20art%2C%20cinematic%20scale%2C%20no%20text&width=600&height=900&seq=wsr-hot-03&orientation=portrait',
  },
  {
    id: 204,
    title: '第七个目击者',
    subtitle: 'The Seventh Witness',
    year: 2024,
    region: '中国大陆',
    genres: ['悬疑', '剧情'],
    rating: 8.9,
    quality: '蓝光',
    duration: '124分钟',
    hot: 91200,
    poster:
      'https://readdy.ai/api/search-image?query=interrogation%20room%20single%20hanging%20bulb%2C%20empty%20chair%20and%20mirror%2C%20desaturated%20grey%20with%20amber%20accent%2C%20psychological%20thriller%20poster%20art%2C%20tense%20mood%2C%20no%20text&width=600&height=900&seq=wsr-hot-04&orientation=portrait',
  },
  {
    id: 205,
    title: '邻居那些事',
    subtitle: 'Neighbors',
    year: 2024,
    region: '中国大陆',
    genres: ['喜剧', '家庭'],
    rating: 8.1,
    quality: '1080P',
    duration: '104分钟',
    hot: 76800,
    poster:
      'https://readdy.ai/api/search-image?query=sunlit%20apartment%20courtyard%20with%20laundry%20lines%20and%20plants%2C%20cheerful%20warm%20yellow%20and%20green%20tones%2C%20warm%20family%20comedy%20poster%20art%2C%20cozy%20daylight%2C%20no%20text&width=600&height=900&seq=wsr-hot-05&orientation=portrait',
  },
  {
    id: 206,
    title: '小小机器人',
    subtitle: 'Little Bot',
    year: 2025,
    region: '日本',
    genres: ['动画', '科幻'],
    rating: 9.0,
    quality: '4K',
    duration: '98分钟',
    hot: 88900,
    poster:
      'https://readdy.ai/api/search-image?query=tiny%20friendly%20robot%20in%20sunlit%20workshop%2C%20gears%20and%20glowing%20core%2C%20warm%20cream%20and%20soft%20orange%20palette%2C%20heartwarming%20animation%20poster%20art%2C%20clean%20background%2C%20no%20text&width=600&height=900&seq=wsr-hot-06&orientation=portrait',
  },
  {
    id: 207,
    title: '春光邮局',
    subtitle: 'Spring Post Office',
    year: 2024,
    region: '中国大陆',
    genres: ['爱情', '剧情'],
    rating: 8.3,
    quality: '1080P',
    duration: '110分钟',
    hot: 71500,
    poster:
      'https://readdy.ai/api/search-image?query=vintage%20small%20town%20post%20office%20in%20spring%2C%20blossoming%20branches%20and%20letters%2C%20soft%20pink%20and%20mint%20palette%2C%20gentle%20romance%20poster%20art%2C%20warm%20daylight%2C%20no%20text&width=600&height=900&seq=wsr-hot-07&orientation=portrait',
  },
  {
    id: 208,
    title: '长夜微光',
    subtitle: 'Glimmer in the Long Night',
    year: 2024,
    region: '中国大陆',
    genres: ['剧情', '悬疑'],
    rating: 8.5,
    quality: '蓝光',
    duration: '132分钟',
    hot: 82400,
    poster:
      'https://readdy.ai/api/search-image?query=single%20window%20warm%20light%20in%20dark%20city%20block%20at%20night%2C%20rain%20streaks%20on%20glass%2C%20deep%20charcoal%20with%20amber%20glow%2C%20moody%20drama%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-hot-08&orientation=portrait',
  },
  {
    id: 209,
    title: '极地信使',
    subtitle: 'Polar Messenger',
    year: 2025,
    region: '加拿大',
    genres: ['冒险', '剧情'],
    rating: 8.2,
    quality: '4K',
    duration: '121分钟',
    hot: 69300,
    poster:
      'https://readdy.ai/api/search-image?query=sled%20dog%20team%20crossing%20vast%20snowfield%20under%20aurora%2C%20lone%20musher%2C%20cool%20ivory%20and%20warm%20teal%20aurora%20accent%2C%20adventure%20poster%20art%2C%20epic%20landscape%2C%20no%20text&width=600&height=900&seq=wsr-hot-09&orientation=portrait',
  },
  {
    id: 210,
    title: '街角火锅店',
    subtitle: 'Corner Hotpot',
    year: 2024,
    region: '中国大陆',
    genres: ['喜剧', '剧情'],
    rating: 8.0,
    quality: '1080P',
    duration: '106分钟',
    hot: 64800,
    poster:
      'https://readdy.ai/api/search-image?query=cozy%20steaming%20hotpot%20table%20in%20small%20restaurant%2C%20warm%20lanterns%20and%20rising%20steam%2C%20rich%20red%20and%20amber%20tones%2C%20hearty%20food%20drama%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-hot-10&orientation=portrait',
  },
  {
    id: 211,
    title: '深海来信',
    subtitle: 'Letter from the Deep',
    year: 2025,
    region: '英国',
    genres: ['科幻', '悬疑'],
    rating: 8.4,
    quality: '4K HDR',
    duration: '118分钟',
    hot: 80100,
    poster:
      'https://readdy.ai/api/search-image?query=deep%20sea%20research%20sub%20in%20dark%20water%20with%20glowing%20particles%2C%20diver%20silhouette%2C%20deep%20blue%20swapped%20to%20deep%20teal%20with%20amber%20glow%2C%20sci-fi%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-hot-11&orientation=portrait',
  },
  {
    id: 212,
    title: '旧日剧场',
    subtitle: 'The Old Theatre',
    year: 2024,
    region: '法国',
    genres: ['剧情', '爱情'],
    rating: 8.6,
    quality: '蓝光',
    duration: '125分钟',
    hot: 73900,
    poster:
      'https://readdy.ai/api/search-image?query=grand%20vintage%20theatre%20interior%20with%20red%20velvet%20seats%20and%20golden%20stage%20light%2C%20empty%20spotlight%2C%20warm%20crimson%20and%20gold%20palette%2C%20classic%20drama%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-hot-12&orientation=portrait',
  },
];

export const hdMovies: Movie[] = [
  {
    id: 301,
    title: '雪线之上',
    subtitle: 'Above the Snowline',
    year: 2025,
    region: '中国大陆',
    genres: ['冒险', '纪录片'],
    rating: 9.2,
    quality: '4K HDR',
    duration: '96分钟',
    hot: 58800,
    poster:
      'https://readdy.ai/api/search-image?query=majestic%20snow%20mountain%20ridge%20at%20sunrise%2C%20climber%20tiny%20silhouette%2C%20crisp%20ivory%20and%20rose%20gold%20alpenglow%2C%20documentary%20poster%20art%2C%20pristine%20detail%2C%20no%20text&width=600&height=900&seq=wsr-hd-01&orientation=portrait',
  },
  {
    id: 302,
    title: '花园四季',
    subtitle: 'Garden Seasons',
    year: 2024,
    region: '英国',
    genres: ['纪录片', '自然'],
    rating: 9.4,
    quality: '4K HDR',
    duration: '88分钟',
    hot: 51200,
    poster:
      'https://readdy.ai/api/search-image?query=lush%20botanical%20garden%20in%20full%20bloom%20with%20dewdrops%2C%20butterflies%2C%20vibrant%20green%20and%20warm%20floral%20tones%2C%20nature%20documentary%20poster%20art%2C%20soft%20light%2C%20no%20text&width=600&height=900&seq=wsr-hd-02&orientation=portrait',
  },
  {
    id: 303,
    title: '城市天际线',
    subtitle: 'City Skyline',
    year: 2025,
    region: '美国',
    genres: ['纪录', '人文'],
    rating: 8.9,
    quality: '4K',
    duration: '92分钟',
    hot: 47600,
    poster:
      'https://readdy.ai/api/search-image?query=aerial%20view%20of%20modern%20city%20skyline%20at%20blue%20hour%20turned%20warm%2C%20glowing%20windows%20and%20amber%20street%20lights%2C%20urban%20documentary%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-hd-03&orientation=portrait',
  },
  {
    id: 304,
    title: '山与海的对话',
    subtitle: 'Mountains and Sea',
    year: 2024,
    region: '新西兰',
    genres: ['纪录', '自然'],
    rating: 9.1,
    quality: '蓝光',
    duration: '84分钟',
    hot: 44800,
    poster:
      'https://readdy.ai/api/search-image?query=dramatic%20coastline%20where%20cliffs%20meet%20turquoise%20sea%2C%20windswept%20grass%2C%20earthy%20amber%20and%20jade%20palette%2C%20nature%20documentary%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-hd-04&orientation=portrait',
  },
  {
    id: 305,
    title: '星野观测',
    subtitle: 'Starfield Watch',
    year: 2025,
    region: '智利',
    genres: ['纪录', '科学'],
    rating: 9.0,
    quality: '4K HDR',
    duration: '90分钟',
    hot: 43100,
    poster:
      'https://readdy.ai/api/search-image?query=observatory%20dome%20under%20brilliant%20milky%20way%2C%20desert%20horizon%2C%20deep%20indigo%20sky%20with%20warm%20amber%20dome%20glow%2C%20astronomy%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-hd-05&orientation=portrait',
  },
  {
    id: 306,
    title: '古堡匠人',
    subtitle: 'Castle Artisans',
    year: 2024,
    region: '意大利',
    genres: ['纪录', '人文'],
    rating: 8.7,
    quality: '蓝光',
    duration: '94分钟',
    hot: 38900,
    poster:
      'https://readdy.ai/api/search-image?query=artisan%20workshop%20inside%20old%20stone%20castle%2C%20hands%20shaping%20clay%2C%20warm%20terracotta%20and%20ochre%20palette%2C%20craft%20documentary%20poster%20art%2C%20soft%20window%20light%2C%20no%20text&width=600&height=900&seq=wsr-hd-06&orientation=portrait',
  },
];

export const classicMovies: Movie[] = [
  {
    id: 401,
    title: '老电影院的夏天',
    subtitle: 'Summer of the Old Cinema',
    year: 1998,
    region: '中国大陆',
    genres: ['剧情', '怀旧'],
    rating: 9.3,
    quality: '修复版',
    duration: '118分钟',
    hot: 42600,
    poster:
      'https://readdy.ai/api/search-image?query=nostalgic%20open%20air%20cinema%20with%20wooden%20benches%20at%20dusk%2C%20projector%20beam%20and%20fireflies%2C%20warm%20sepia%20and%20amber%20tones%2C%20retro%20drama%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-classic-01&orientation=portrait',
  },
  {
    id: 402,
    title: '远方来客',
    subtitle: 'The Visitor',
    year: 1986,
    region: '中国大陆',
    genres: ['剧情', '文艺'],
    rating: 9.0,
    quality: '修复版',
    duration: '126分钟',
    hot: 37800,
    poster:
      'https://readdy.ai/api/search-image?query=lonely%20train%20station%20platform%20in%20autumn%20fog%2C%20traveler%20with%20old%20suitcase%2C%20muted%20ochre%20and%20soft%20grey%2C%20vintage%20literary%20film%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-classic-02&orientation=portrait',
  },
  {
    id: 403,
    title: '风起麦田',
    subtitle: 'Wind over the Wheat',
    year: 1992,
    region: '中国大陆',
    genres: ['剧情', '乡土'],
    rating: 9.1,
    quality: '修复版',
    duration: '134分钟',
    hot: 35400,
    poster:
      'https://readdy.ai/api/search-image?query=golden%20wheat%20field%20rippling%20in%20warm%20breeze%20under%20huge%20sky%2C%20distant%20farmhouse%2C%20rich%20amber%20and%20soft%20green%2C%20rural%20drama%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-classic-03&orientation=portrait',
  },
  {
    id: 404,
    title: '雨巷往事',
    subtitle: 'Rainy Lane',
    year: 1995,
    region: '中国香港',
    genres: ['爱情', '文艺'],
    rating: 8.8,
    quality: '修复版',
    duration: '112分钟',
    hot: 33200,
    poster:
      'https://readdy.ai/api/search-image?query=old%20stone%20lane%20in%20rain%20with%20warm%20street%20lamp%2C%20two%20figures%20sharing%20umbrella%2C%20muted%20rose%20and%20sepia%20palette%2C%20nostalgic%20romance%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-classic-04&orientation=portrait',
  },
];

export const upcomingMovies: UpcomingMovie[] = [
  {
    id: 501,
    title: '远星计划',
    month: '11月待映',
    reason: '硬核科幻世界观，重启深空探索题材',
    genre: '科幻 · 冒险',
    poster:
      'https://readdy.ai/api/search-image?query=fleet%20of%20exploration%20ships%20heading%20toward%20distant%20star%2C%20warm%20amber%20engine%20glow%2C%20epic%20sci-fi%20teaser%20poster%20art%2C%20starfield%20backdrop%2C%20no%20text&width=600&height=900&seq=wsr-up-01&orientation=portrait',
  },
  {
    id: 502,
    title: '无声证词',
    month: '12月待映',
    reason: '改编自真实卷宗的法庭悬疑新作',
    genre: '悬疑 · 剧情',
    poster:
      'https://readdy.ai/api/search-image?query=empty%20courtroom%20with%20single%20beam%20of%20light%20through%20tall%20window%2C%20wooden%20benches%2C%20muted%20amber%20and%20grey%2C%20legal%20thriller%20teaser%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-up-02&orientation=portrait',
  },
  {
    id: 503,
    title: '森林之歌',
    month: '2026年1月待映',
    reason: '手绘质感的原创动画长片',
    genre: '动画 · 奇幻',
    poster:
      'https://readdy.ai/api/search-image?query=enchanted%20forest%20with%20glowing%20spirits%20and%20ancient%20trees%2C%20deer%20silhouette%2C%20storybook%20green%20and%20warm%20gold%20palette%2C%20animation%20teaser%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-up-03&orientation=portrait',
  },
  {
    id: 504,
    title: '最后一班地铁',
    month: '2026年2月待映',
    reason: '都市群像叙事，多条故事线交汇',
    genre: '剧情 · 都市',
    poster:
      'https://readdy.ai/api/search-image?query=last%20subway%20train%20interior%20at%20night%20with%20warm%20interior%20lights%2C%20empty%20platform%2C%20amber%20and%20deep%20charcoal%20palette%2C%20urban%20drama%20teaser%20poster%20art%2C%20no%20text&width=600&height=900&seq=wsr-up-04&orientation=portrait',
  },
];

export const genreCategories: GenreCategory[] = [
  { id: 1, name: '动作片', count: 1286, icon: 'ri-sword-line', desc: '追逐、爆破与硬核打斗，肾上腺素拉满' },
  { id: 2, name: '科幻片', count: 742, icon: 'ri-planet-line', desc: '深空、未来与赛博想象，拓宽世界边界' },
  { id: 3, name: '喜剧片', count: 1035, icon: 'ri-emotion-happy-line', desc: '轻松解压，适合与家人朋友一起放松' },
  { id: 4, name: '悬疑片', count: 864, icon: 'ri-magic-line', desc: '层层反转，跟着线索一起抽丝剥茧' },
  { id: 5, name: '剧情片', count: 1580, icon: 'ri-book-open-line', desc: '聚焦人物与情感，值得细细品味的佳作' },
  { id: 6, name: '动画片', count: 613, icon: 'ri-bear-smile-line', desc: '从合家欢到治愈系，画面与故事双重享受' },
  { id: 7, name: '爱情片', count: 908, icon: 'ri-heart-line', desc: '关于相遇与陪伴的温柔故事合集' },
  { id: 8, name: '纪录片', count: 476, icon: 'ri-earth-line', desc: '真实世界的光影记录，拓宽认知边界' },
];

export const guideSteps: GuideStep[] = [
  {
    id: 1,
    title: '从今日更新入手',
    desc: '首页顶部按时间顺序列出当天上新的影片，标注清晰度与类型标签，点开即可找到播放入口。',
    icon: 'ri-calendar-check-line',
  },
  {
    id: 2,
    title: '用类型筛选缩小范围',
    desc: '在热门影片区切换动作、科幻、悬疑等标签，或直接输入片名关键词，列表会即时过滤出结果。',
    icon: 'ri-filter-3-line',
  },
  {
    id: 3,
    title: '按清晰度挑选画质',
    desc: '喜欢极致画质的观众可优先进入高清专区，这里汇集了 4K HDR、蓝光与原盘修复版本。',
    icon: 'ri-hd-line',
  },
  {
    id: 4,
    title: '按评分与热度排序',
    desc: '不确定看什么时，参考热度指数与评分快速决策，热门榜单每天随播放数据更新。',
    icon: 'ri-fire-line',
  },
];

export const faqItems: FaqItem[] = [
  {
    id: 1,
    q: '西瓜影院的“今日更新”多久刷新一次？',
    a: '更新列表会在每天上午与傍晚各整理一次，把当天新上架的影片按时间顺序排列，并同步标注清晰度、类型与地区，方便你第一时间看到最新电影资源。',
  },
  {
    id: 2,
    q: '如何快速找到想看的类型或片名？',
    a: '可以在热门影片区点击类型标签，或使用搜索框输入片名、类型关键词。筛选只作用于本页已经展示的内容，结果会即时呈现，不需要跳转到其他页面。',
  },
  {
    id: 3,
    q: '“高清专区”里的影片和普通影片有什么区别？',
    a: '高清专区只收录 4K HDR、蓝光、原盘或修复版本，适合在较大屏幕和更好的网络环境下观看；普通列表则同时包含 1080P 等常用清晰度，方便按需选择。',
  },
  {
    id: 4,
    q: '评分和热度指数是怎么来的？',
    a: '评分用于参考整体口碑，热度指数反映近期关注度，两者都用于帮助你排序和挑选。它们会随数据变化而调整，仅作为挑片时的辅助参考。',
  },
  {
    id: 5,
    q: '找不到想看的影片怎么办？',
    a: '可以换一个类型标签，或缩短搜索关键词再试一次。电影大全分类按题材整理了当前收录的影片数量，从分类入口浏览往往也能发现不少值得一看的片子。',
  },
];